import { TValidator } from './types';

export const maxChars = (chars: number): TValidator => (value: string) =>
  value && value.length > chars ? 'Too many chars' : undefined;
